import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import 'moment/locale/nl';

import {
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import { CoreLink, Table } from '../../../../components';
import './style.scss';

moment.locale('nl');

const ViewForumCategories = ({ entities, className }) => {
  const { t } = useTranslation();

  return (
    <div className={`ViewForumCategories ${className}`}>
      <Table>
        <Table.Head>
          <Table.Row>
            <Table.Cell>{t('pages.forum.categories.labels.category')}</Table.Cell>
            <Table.Cell>{t('pages.forum.categories.labels.last_response')}</Table.Cell>
            <Table.Cell>{t('pages.forum.categories.labels.number_of_posts')}</Table.Cell>
            <Table.Cell>{t('pages.forum.categories.labels.number_of_comments')}</Table.Cell>
          </Table.Row>
        </Table.Head>
        <Table.Body>
          {entities.map((item) => {
            const lastCommentDate = item.get('last_comment_timestamp') && moment(item.get('last_comment_timestamp'));

            return (
              <Table.Row key={item.get('tid')}>
                <Table.Cell>
                  <WysiwygField
                    property="schema:text"
                    html={item.get('name')}
                    customElementHandler={(element) => {
                      if (element.name) {
                        return (
                          <CoreLink to={element.attribs.href} className="u-word-break">
                            {element.children[0].data}
                          </CoreLink>
                        );
                      }
                    }}
                  />
                </Table.Cell>
                <Table.Cell>
                  <div className="Table__Cell__label">{t('pages.forum.categories.labels.last_response')}:&nbsp;</div>
                  {lastCommentDate && (
                    <span>{lastCommentDate.fromNow()}</span>
                  )}
                </Table.Cell>
                <Table.Cell>
                  <div className="Table__Cell__label">{t('pages.forum.categories.labels.number_of_posts')}:&nbsp;</div>
                  <span>{item.get('nid')}</span>
                </Table.Cell>
                <Table.Cell>
                  <div className="Table__Cell__label">{t('pages.forum.categories.labels.number_of_comments')}:&nbsp;</div>
                  <span>{item.get('cid')}</span>
                </Table.Cell>
              </Table.Row>
            );
          })}
        </Table.Body>
      </Table>
    </div>
  );
};

export default ViewForumCategories;
